import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { IoIosArrowUp } from "react-icons/io";
import resetBtn from "../../../assets/images/reset-arrow.svg";
import downloadBtn from "../../../assets/images/filter-download-btn.svg";
import {
  getCmsServiceSection,
  deleteCmsServiceSectionById,
} from "../../../actions/cmsServicePageAction";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import FullPageLoader from "../../../components/FullPageLoader/FullPageLoader";
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
import DataTable, { createTheme } from "react-data-table-component";

createTheme(
  "solarized",
  {
    text: {
      primary: "#000",
      secondary: "#000",
    },
    background: {
      default: "#fff",
    },
    context: {
      background: "#cb4b16",
      text: "#FFFFFF",
    },
    divider: {
      default: "#DFE0EB",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  },
  "dark"
);

const ServicePageSections = () => {
  const [cmsServiceSection, setCmsServiceSection] = useState([]);
  const [loader, setLoader] = useState(false);
  const { admin } = useSelector((state) => state.admin);
  const currentUserRole = admin.role;
  const [getDelete, setDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [filterText, setFilterText] = useState("");
  const [selectedOption, setSelectedOption] = useState();
  const [filteredItems, setFilteredItems] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const hideModel = () => {
    setDelete(false);
  };
  const deleteCmsServiceSection = async () => {
    setDelete(false);
    setLoader(true);
    let res = await deleteCmsServiceSectionById(deleteId);
    if (res.data.success) {
      toast.success(res.data.message);
      getAllCmsServiceSection();
    }
    setLoader(false);
  };
  const showModel = (id) => {
    setDeleteId(id);
    setDelete(true);
  };

  const getAllCmsServiceSection = async () => {
    setLoader(true);
    let res = await getCmsServiceSection();
    if (res.data.data.contentPages) {
      setCmsServiceSection(res.data.data.contentPages);
    }
    setLoader(false);
  };
  useEffect(() => {
    getAllCmsServiceSection();
  }, []);

  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA?.heading?.toLowerCase();
    const b = rowB?.heading?.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const columns = [
    {
      name: "Heading",
      selector: (row) => row?.heading,
    },
    {
      name: "Slug",
      selector: (row) => row?.slug.toLowerCase(),
    },
    {
      name: "Sub Heading",
      selector: (row) => row?.sub_heading,
    },
    {
      name: "Status",
      selector: (row) => (
        <>
          {row.status ? (
            <label className="label label-success m-0">Active</label>
          ) : (
            <label className="label label-danger m-0">Inactive</label>
          )}
        </>
      ),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="td-actions table-actions-btns">
          <ul className="list-unstyled mb-0 d-flex justify-content-center">
            {currentUserRole?.editCmsServiceSection ? (
              <li className="d-inline-block align-top">
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-436082023">Edit</Tooltip>}
                  placement="left"
                >
                  <Link
                    to={`/cms/service/edit/${row._id}`}
                    type="button"
                    className="btn-link btn-icon btn btn-success"
                  >
                    <FaEdit />
                  </Link>
                </OverlayTrigger>
              </li>
            ) : (
              <li className="d-inline-block align-top">
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-436082023">Edit</Tooltip>}
                  placement="left"
                >
                  <Link
                    to={""}
                    type="button"
                    className="btn-link btn-icon btn btn-success disabled"
                    disabled
                  >
                    <FaEdit />
                  </Link>
                </OverlayTrigger>
              </li>
            )}

            {currentUserRole?.deleteCmsServiceSection ? (
              <li className="d-inline-block align-top">
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-436082023">Delete</Tooltip>}
                  placement="left"
                >
                  <button
                    onClick={() => showModel(row._id)}
                    type="button"
                    className="btn-link btn-icon btn btn-danger"
                  >
                    <FaTrash />
                  </button>
                </OverlayTrigger>
              </li>
            ) : (
              <li className="d-inline-block align-top">
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-436082023">Delete</Tooltip>}
                  placement="left"
                >
                  <button
                    type="button"
                    className="btn-link btn-icon btn btn-danger disabled"
                    disabled
                  >
                    <FaTrash />
                  </button>
                </OverlayTrigger>
              </li>
            )}
          </ul>
        </div>
      ),
      sortable: false,
    },
  ];
  const filterDatatable = (text) => {
    setFilterText(text);
    filterSearchDatatable(selectedOption, text);
  };

  const filterSearchDatatable = (text, searchText) => {
    const filteredItemsResult = cmsServiceSection.filter((data) => {
      if (text) {
        if (
          data.status.toString().toLowerCase().includes(text.toLowerCase()) &&
          (data?.heading.toLowerCase().includes(searchText.toLowerCase()) ||
            data?.slug.toLowerCase().includes(searchText.toLowerCase()) ||
            data?.sub_heading.toLowerCase().includes(searchText.toLowerCase()))
        ) {
          return data;
        }
      } else if (
        data?.heading.toLowerCase().includes(searchText.toLowerCase()) ||
        data?.slug.toLowerCase().includes(searchText.toLowerCase()) ||
        data?.sub_heading.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return data;
      }
      return undefined;
    });
    setFilteredItems([...filteredItemsResult]);
    setSelectedOption(text);
  };

  const resetFilter = () => {
    setFilterText("");
    setFilteredItems([...cmsServiceSection]);
    setSelectedOption("");
  };

  const toggleFilterAccordion = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  useEffect(() => {
    if (cmsServiceSection) {
      setFilteredItems([...cmsServiceSection]);
    }
  }, [cmsServiceSection]);
  return (
    <>
      {getDelete ? (
        <SweetAlert
          warning
          showCloseButton
          showCancel
          confirmBtnText="Yes"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="light"
          title="Are you sure you want to delete?"
          onConfirm={deleteCmsServiceSection}
          onCancel={hideModel}
          focusCancelBtn
          customClass="del-sweet-alert"
        >
          You will not be able to recover this data!
        </SweetAlert>
      ) : null}
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3">
          <Container fluid>
            <Row>
              {/* Start of filter container */}
              <Col md="12">
                <Card className="filter-card card">
                  <Card.Header 
                    style={{ cursor: "pointer" }}
                    onClick={toggleFilterAccordion}
                  >
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Filter
                      </Card.Title>
                      <div 
                        style={{ 
                          transform: isFilterOpen ? "rotate(0deg)" : "rotate(180deg)",
                          transition: "transform 0.3s ease"
                        }}
                      >
                        <IoIosArrowUp />
                      </div>
                    </div>
                     
                  </Card.Header>
                  {isFilterOpen && (
                  <Card.Body>
                    <Row>
                      <Col xl={4} sm={6} className="search-wrap">
                        <Form.Group>
                          <Form.Label className="d-block mb-2 text-white">
                            Search with title...
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="search"
                            placeholder="Search"
                            value={filterText}
                            onChange={(e) => filterDatatable(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col xl={4} sm={6} className="search-wrap">
                        <Form.Group>
                          <Form.Label className="d-block mb-2 text-white">
                            Filter with status...
                          </Form.Label>
                          <select
                            value={selectedOption}
                            onChange={(e) =>
                              filterSearchDatatable(e.target.value, filterText)
                            }
                          >
                            <option value="">Select Status</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                          </select>
                        </Form.Group>
                      </Col>
                      <Col xl={4} md={6}>
                        <Form.Group>
                          <label className="d-none d-sm-block mb-2 form-label">
                            &nbsp;
                          </label>
                          <div className="d-flex  filter-btns-holder">
                            <button
                              type="button"
                              className="outline-button filter-reset-btn"
                              onClick={() => resetFilter()}
                            >
                              <img src={resetBtn} className="img-fluid mr-3" alt="logo"/>
                              Reset
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                  )}
                </Card>

                <div className="datatable-title card d-flex flex-row justify-content-between align-items-center mb-0">
                  <h4 className="card-title">Services Page Sections</h4>
                  {currentUserRole?.addCmsServiceSection ? (
                    <div className="btn-add">
                      <Link
                        className="float-sm-right btn-filled d-flex align-items-center"
                        to="/cms/service/add"
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>{" "}
                        Add Service
                      </Link>
                    </div>
                  ) : (
                    <div className="btn-add">
                      <Button
                        className="float-sm-right btn-filled d-flex align-items-center disabled"
                        disabled
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>{" "}
                        Add Service{" "}
                      </Button>
                    </div>
                  )}
                </div>
                 <div className="custom-datatable-pagination">
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  theme="solarized"
                  pagination
                  className="react-datatable"
                />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default ServicePageSections;
